import { staticComponentValueConverter } from '../StaticComponentValues';
import { useMemo } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';

function SingleProductBase({ item, Product }) {
  const images = item?.data?.images || [];
  const min = item?.variantData?.minImage;
  const customization = staticComponentValueConverter(item?.customization);
  const heartIconFilter = useMemo(
    () => HexToHueConverter(customization?.heartIconColor),
    [customization?.heartIconColor],
  );
  const cartIconFilter = useMemo(() => HexToHueConverter(customization?.cartIconColor), [customization?.cartIconColor]);
  const discountIconFilter = useMemo(
    () => HexToHueConverter(customization?.discountIconColor),
    [customization?.discountIconColor],
  );
  return (
    <>
      {images?.length >= min ? (
        <div
          className="`overflow-x-visible relative"
          style={{
            padding: `${customization?.containerPadding}`,
            backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
            backgroundImage:
              customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <div
            style={{
              fontWeight: customization?.textWeight,
              fontStyle: customization?.textStyle,
              fontSize: customization?.textSize,
              color: customization?.textColor,
              textAlign: customization?.textAlignment,
              letterSpacing: customization?.textLetterSpacing,
              marginLeft: '10px',
              marginRight: '10px',
            }}
          >
            {item?.data?.text}
          </div>
          <Product
            item={item}
            productWidth={100}
            customization={customization}
            imgObj={images?.[0]}
            iconFilters={{ heartIconFilter, cartIconFilter, discountIconFilter }}
          />
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </>
  );
}

export default SingleProductBase;
